import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner/banner.component';
import { SearchComponent } from './search/search.component';
import { ContentCardsComponent } from './content-cards/content-cards.component';
import { BeachWatchMapModule } from '../beach-watch-map/beach-watch-map.module';
import { HomeComponent } from './home.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SubscribeSectionComponent } from './subscribe-section/subscribe-section.component';
import { RouterModule } from '@angular/router';
import { SharedCompsModule } from '../shared/shared-comps.module';
import { AppMonitoringService } from '../services/logging.service';


@NgModule({
	declarations: [
		BannerComponent,
		SearchComponent,
		ContentCardsComponent,		
		HomeComponent,		
		SubscribeSectionComponent,
	],
	imports: [
		CommonModule, 
		BeachWatchMapModule, 
		FormsModule, 
		MatAutocompleteModule, 
		RouterModule,
		SharedCompsModule,
		ReactiveFormsModule
	],
	exports :[HomeComponent],providers : [AppMonitoringService]
})
export class HomeModule {}
